import { render } from "./CashBook.vue?vue&type=template&id=2a702b4f&scoped=true&ts=true"
import script from "./CashBook.vue?vue&type=script&lang=ts"
export * from "./CashBook.vue?vue&type=script&lang=ts"

import "./CashBook.vue?vue&type=style&index=0&id=2a702b4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a702b4f"]])

export default __exports__